"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _TabLayout = _interopRequireDefault(require("pricing-pages-unified-ui/components/TabLayout"));

var _reactRhumb = require("react-rhumb");

var _PageContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/PageContainer"));

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _reactRedux = require("react-redux");

var _StyledBlob = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/StyledBlob"));

var _FailedLoadBanner = _interopRequireDefault(require("pricing-pages-unified-ui/components/loading/FailedLoadBanner"));

var _BannerSection = _interopRequireDefault(require("pricing-pages-unified-ui/components/banners/BannerSection"));

var _CustomerSupport = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/CustomerSupport"));

var _Faq = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Faq"));

var _FooterMicrocopy = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/FooterMicrocopy"));

var _PhoneSupportFooter = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/PhoneSupportFooter"));

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _HubInfoContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/HubInfoContainer"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _DocumentUtils = require("pricing-pages-unified-ui/utils/DocumentUtils");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _HubSubtitle = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/HubSubtitle"));

var _StandardProductPageTitle = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/StandardProductPageTitle"));

var _ProductsAndPlansNavIds = require("pricing-pages-unified-ui/constants/ProductsAndPlansNavIds");

var SelfServiceHubs = _interopRequireWildcard(require("self-service-api/constants/Hubs"));

var _HubTierInfo = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/HubTierInfo"));

var _MigrateYourSite = _interopRequireDefault(require("pricing-pages-unified-ui/components/cms-hub-page/MigrateYourSite"));

var _PhoneSupport = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/PhoneSupport"));

var _PhoneSupportWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/phone-numbers/PhoneSupportWrapper"));

var _Question = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Question"));

var _ExperimentTreatmentSelectors = require("pricing-pages-unified-ui/selectors/ExperimentTreatmentSelectors");

var _Mon317ProductPageTitle = _interopRequireDefault(require("pricing-pages-unified-ui/components/cms-hub-page/Mon317ProductPageTitle"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

var _Mon317Carousel = _interopRequireDefault(require("pricing-pages-unified-ui/components/cms-hub-page/Mon317Carousel"));

var _laboratoryClient = require("laboratory-client");

var _CurrencyPicker = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/CurrencyPicker"));

var _ExperimentConstants = require("pricing-pages-unified-ui/constants/ExperimentConstants");

var _Mon307TalkToSalesAuthedCta = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Mon307TalkToSalesAuthedCta"));

var _Mon307StickyTtsBar = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Mon307StickyTtsBar"));

var _Mon307Fab = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Mon307Fab"));

var _stateUtils = require("../../utils/stateUtils");

var _queryParamUtils = require("../../utils/queryParamUtils");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    max-width: initial;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  max-width: 792px;\n  margin-left: auto;\n  margin-right: auto;\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-left: auto;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-left: 0;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var LeftAlignedProductPageTitle = (0, _styledComponents.default)(_StandardProductPageTitle.default).withConfig({
  displayName: "CmsHubPage__LeftAlignedProductPageTitle",
  componentId: "mumidk-0"
})(_templateObject(), _responsiveBreakpoints.default.tabletPortrait(_templateObject2()));
var ThinBannerSection = (0, _styledComponents.default)(_BannerSection.default).withConfig({
  displayName: "CmsHubPage__ThinBannerSection",
  componentId: "mumidk-1"
})(_templateObject3(), _responsiveBreakpoints.default.sd(_templateObject4()));

var CmsHubPage = function CmsHubPage(_ref) {
  var hasPricingAndPurchasingSucceeded = _ref.hasPricingAndPurchasingSucceeded,
      hasPricingAndPurchasingFailed = _ref.hasPricingAndPurchasingFailed,
      mon317IsContentForward = _ref.mon317IsContentForward,
      mon317Treatment = _ref.mon317Treatment;
  (0, _react.useEffect)(function () {
    (0, _getUsageTracker.default)().track('pageView', {
      screen: _Tracking.SCREENS.PRODUCTS_PLANS,
      subscreen: _Tracking.SUBSCREENS.CMS_HUB
    });
  }, []);
  (0, _react.useEffect)(function () {
    if (!mon317Treatment.isMocked) {
      (0, _laboratoryClient.logExposure)(mon317Treatment);
    }
  }, []);
  var mon307Treatment = (0, _reactRedux.useSelector)(_ExperimentTreatmentSelectors.mon307TreatmentSelector);
  (0, _react.useEffect)(function () {
    if (!mon307Treatment.isMocked) {
      (0, _laboratoryClient.logExposure)(mon307Treatment);
    }
  }, []);
  var mon307TtsStyle = (0, _reactRedux.useSelector)(_ExperimentTreatmentSelectors.mon307TtsStyleSelector);

  var _useActiveTerm = (0, _stateUtils.useActiveTerm)(),
      term = _useActiveTerm.activeTerm;

  (0, _queryParamUtils.useQueryParamsEffect)({
    term: term
  });
  return _react.default.createElement(_TabLayout.default, {
    selectedPrimaryTab: "products",
    selectedSecondaryTab: "cms"
  }, mon307TtsStyle === _ExperimentConstants.MON307_TTS_STYLE_OPTIONS.STICKY_HEADER && _react.default.createElement(_Mon307StickyTtsBar.default, {
    hub: SelfServiceHubs.default.HUB_CMS
  }), _react.default.createElement(_PageContainer.default, {
    "data-selenium-id": "page-success"
  }, hasPricingAndPurchasingSucceeded && _react.default.createElement(_reactRhumb.NavMarker, {
    name: "CMS_PAGE"
  }), mon307TtsStyle === _ExperimentConstants.MON307_TTS_STYLE_OPTIONS.SIDE_FAB && _react.default.createElement(_Mon307Fab.default, {
    hub: SelfServiceHubs.default.HUB_CMS
  }), _react.default.createElement(_CurrencyPicker.default, {
    mon307MoveDown: mon307TtsStyle === _ExperimentConstants.MON307_TTS_STYLE_OPTIONS.SIDE_FAB
  }), _react.default.createElement(_StyledBlob.default, null), _react.default.createElement(_HubInfoContainer.default, null, _react.default.createElement(_FailedLoadBanner.default, {
    hasFailed: hasPricingAndPurchasingFailed
  }), mon317IsContentForward ? _react.default.createElement(_Mon317ProductPageTitle.default, {
    className: "m-bottom-8",
    standardProductPageTitle: _react.default.createElement(LeftAlignedProductPageTitle, {
      hub: _ProductsAndPlansNavIds.CMS_HUB,
      isNew: true,
      className: "m-bottom-5",
      includeTrademark: true
    })
  }) : _react.default.createElement(_StandardProductPageTitle.default, {
    hub: _ProductsAndPlansNavIds.CMS_HUB,
    isNew: true,
    includeTrademark: true
  }), !mon317IsContentForward && _react.default.createElement(_HubSubtitle.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricing-pages.hubs.cmsHub.description"
  })), mon307TtsStyle === _ExperimentConstants.MON307_TTS_STYLE_OPTIONS.BELOW_TITLE && _react.default.createElement("div", {
    className: "justify-center m-bottom-5"
  }, _react.default.createElement(_Mon307TalkToSalesAuthedCta.default, {
    hub: SelfServiceHubs.default.HUB_CMS,
    className: "p-y-4 p-x-7",
    location: _Tracking.BELOW_TITLE
  })), _react.default.createElement(ThinBannerSection, {
    hub: _ProductsAndPlansNavIds.CMS_HUB
  }), _react.default.createElement(_HubTierInfo.default, {
    hub: SelfServiceHubs.HUB_CMS
  }), _react.default.createElement(_PhoneSupportWrapper.default, null, _react.default.createElement(_PhoneSupport.default, {
    phoneSourceId: "cms-middle",
    screen: _Tracking.SUBSCREENS.CMS_HUB
  })), _react.default.createElement("div", {
    style: {
      marginTop: '64px',
      marginBottom: mon317IsContentForward ? 16 : 0
    }
  }, _react.default.createElement(_MigrateYourSite.default, null)), !mon317IsContentForward && _react.default.createElement(_CustomerSupport.default, {
    className: "m-top-10"
  }), mon317IsContentForward && _react.default.createElement(_Mon317Carousel.default, {
    style: {
      marginTop: 120,
      marginBottom: 40
    }
  }), _react.default.createElement(_Faq.default, null, _react.default.createElement(_Question.default, {
    questionKey: "cmsHub.supportIncluded"
  }), _react.default.createElement(_Question.default, {
    questionKey: "cmsHub.developerTeams"
  }), _react.default.createElement(_Question.default, {
    questionKey: "cmsHub.integrate"
  }), _react.default.createElement(_Question.default, {
    questionKey: "cmsHub.migrate"
  }), _react.default.createElement(_Question.default, {
    questionKey: "cmsHub.otherProductLines",
    href: "/bundle",
    externalLink: false
  }), _react.default.createElement(_Question.default, {
    questionKey: "cmsHub.onboarding"
  }), _react.default.createElement(_FooterMicrocopy.default, null)), _react.default.createElement(_PhoneSupportFooter.default, {
    phoneSourceId: "cms-footer",
    screen: _Tracking.SUBSCREENS.CMS_HUB
  }))));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state),
    hasPricingAndPurchasingFailed: (0, _LoadingStateSelectors.hasPricingAndPurchasingFailedSelector)(state),
    mon317IsContentForward: (0, _ExperimentTreatmentSelectors.mon317IsContentForwardSelector)(state),
    mon317Treatment: (0, _ExperimentTreatmentSelectors.mon317TreatmentSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _DocumentUtils.withDocumentTitle)(CmsHubPage, 'cms'));

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/cms-hub-page/CmsHubPage.js
// module id = 871
// module chunks = 5 6